import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export abstract class DocumentService {
  public abstract getUrl(fileLocationNumber: string): Observable<string>;
}
